import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subsidiary-company',
  templateUrl: './subsidiary-company.component.html',
  styleUrls: ['./subsidiary-company.component.css']
})
export class SubsidiaryCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
